
import { Component, Prop } from 'vue-property-decorator';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';

interface MilesAndMoreFormModel {
  clientKey: string;
  clientSecret: string;
}

@Component({
  components: { VFormBuilder },
})
export default class MilesAndMoreForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: MilesAndMoreFormModel };
  };

  public milesAndMoreEnabled: boolean = false;

  get items() {
    return [
      {
        name: 'clientKey',
        type: InputType.Text,
        label: 'venue.form.clientKey',
        rules: 'required',
        autocomplete: 'off',
      },
      {
        name: 'clientSecret',
        type: InputType.Password,
        label: 'venue.form.clientSecret',
        rules: 'required',
        autocomplete: 'off',
      },
      {
        name: 'property',
        type: InputType.Text,
        label: 'venue.form.property',
        rules: 'required',
        autocomplete: 'off',
      },
    ];
  }

  public created() {
    this.milesAndMoreEnabled = !!(this.initialValues as any)?.milesAndMoreEnabled;
  }

  public getData() {
    return {
      milesAndMoreEnabled: this.milesAndMoreEnabled,
      milesAndMoreCredentials: this.milesAndMoreEnabled ? this.$refs.form.getData() : undefined,
    };
  }
}
